import Button from "@components/common/Button";
import ExclamationIcon from "@components/icons/ExclamationIcon";
import { fetchRebootTerminal } from "@services/vesselService";
import { Modal } from "flowbite-react";
import { useState } from "react";
import { customModalTheme } from "styles/customTheme";

export const ModalConfirmationRebootTerminal = ({
	isOpen,
	closeModal,
	onConfirm,
	kitId,
	kitNumber,
	token,
	showAlert,
}) => {
	const [loadingSubmit, setLoadingSubmit] = useState(false);

	const handleSubmit = async () => {
		setLoadingSubmit(true);

		try {
			await fetchRebootTerminal(kitId, token);
			closeModal();
			showAlert("success", "Terminal rebooted successfully", 1500);
		} catch (err) {
			showAlert("error", err.message || "An error occurred while rebooting the terminal", 2000);
		} finally {
			setLoadingSubmit(false);
		}
	};
	return (
		<>
			<Modal show={isOpen} onClose={closeModal} size="2xl" theme={customModalTheme}>
				<Modal.Header className="border-none bg-gray-900" />
				<Modal.Body className="custom-scrollbar bg-gray-900 py-0">
					<div className="space-y-8">
						<div className="flex flex-col items-center justify-center text-center">
							<ExclamationIcon className="!text-[#727DA3db] w-[30px] md:h-[50px] md:w-[50px] lg:h-[50px] lg:w-[50px]" />
						</div>
						<div className="flex items-center justify-center">
							<div className="text-center">
								<p>
									Are you sure you want to restart Starlink terminal {kitNumber}? This will
									temporarily interrupt the service.
								</p>
							</div>
						</div>
					</div>
				</Modal.Body>

				<Modal.Footer className="flex justify-center border-t border-none">
					<Button
						text={loadingSubmit ? "Loading..." : "Confirm"}
						onClick={() => handleSubmit()}
						className="!px-6 !py-2.5 !text-sm !min-w-[80px] bg-button-bg text-white hover:bg-button-hover"
						disabled={loadingSubmit}
					/>
					<Button
						text={"Cancel"}
						color="gray"
						onClick={closeModal}
						className="!px-6 !py-2.5 !text-sm !min-w-[80px] bg-gray-200 text-blue-gray hover:bg-button-cancel-hover hover:text-dark-blue"
					/>
				</Modal.Footer>
			</Modal>
		</>
	);
};
